import { Box, Container, Grid } from '@mui/material'
import { SectionHeading } from '@/components/common'
import { processSteps } from '@/data/process'
import { ProcessStepCard } from './ProcessStepCard'

/**
 * Process Section Component
 * 3-step process visualization
 */
export const ProcessSection = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <SectionHeading align="center" underline>
          Our Simple Process
        </SectionHeading>

        <Grid container spacing={{ xs: 6, md: 4 }} sx={{ mt: 2 }}>
          {processSteps.map((step, index) => (
            <Grid item xs={12} md={4} key={step.stepNumber}>
              <ProcessStepCard
                step={step}
                showArrow={index < processSteps.length - 1}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}
